import React from 'react';
// import _ from 'lodash';

import { 
  buildSourceURL,
} from '../../utils/functions';
import styles from './Basket.module.css';

const Product = ({ product }) => {
  const renderImage = (image) => {
    if (image) {
      return (
        <img className={styles.image} src={buildSourceURL(product.image)} />
      );
    }

    return (
      <div className={styles.withoutImage}>
        No picture
      </div>
    );
  };

  return (
    <div className={styles.productBlock}>
      <div className={styles.imageBlock}>
        {renderImage(product.image)}
      </div>
      <div className={styles.productAmount}>
        {product.sale_amount} {product.name}
      </div>
    </div>
  );
};

export default Product;